import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { IconInfo, IconSavings } from '@redteclab/icons'
import { type FC } from 'react'

import {
  EXPERIMENT_VARIATION,
  MARKETPLACE_HARMONIZATION,
} from 'shared/experiments/consts'
import { useGetExperiment } from 'shared/experiments/utils/experiments'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

import 'views/components/organisms/VolumePricingModal/VolumePricingModal.scss'

interface VolumePricingModalNotificationProps {
  volumeDiscount: number
  volumeQuantity: number
  volumeDiscountActivated: boolean
}

const VolumePricingModalNotification: FC<
  VolumePricingModalNotificationProps
> = ({ volumeDiscount, volumeQuantity, volumeDiscountActivated }) => {
  const marketplaceHarmonization = useGetExperiment(MARKETPLACE_HARMONIZATION)

  const isMarketplaceHarmonizationEnabled =
    marketplaceHarmonization.isEnabled &&
    marketplaceHarmonization.variant === EXPERIMENT_VARIATION.V1

  const volumenDiscountLabel = volumeDiscountActivated
    ? i18n._('volumePricing.pdp.label.maxDiscount.text', {
        discount: volumeDiscount,
      })
    : i18n._('volumePricing.pdp.label.text', {
        discount: volumeDiscount,
        quantity: volumeQuantity,
      })

  return (
    <div className="o-VolumePricingModalNotification">
      <div>
        {isMarketplaceHarmonizationEnabled ? (
          <span className="o-VolumePricingModalNotification__icon--background o-VolumePricingModalNotification__icon--market-harmonization">
            <IconSavings />
          </span>
        ) : (
          <span className="o-VolumePricingModalNotification__icon--background">
            <IconInfo className="o-VolumePricingModalNotification__icon" />
          </span>
        )}
      </div>
      <div className="VolumePricingModalNotification__content">
        {isMarketplaceHarmonizationEnabled ? (
          <>
            <h3 className="o-VolumePricingModalNotification__title--market-harmonization">
              {volumenDiscountLabel}
            </h3>
            <span className="rebranding">
              <Trans id="volumePricing.modal.notification.content" />
            </span>
          </>
        ) : (
          <>
            <h3 className="o-VolumePricingModalNotification__content--title">
              <Trans id="volumePricing.modal.notification.title" />
            </h3>
            <span className="rebranding VolumePricingModalNotification__text">
              <Trans id="volumePricing.modal.notification.content" />
            </span>
          </>
        )}
      </div>
    </div>
  )
}

export default withShopAndRuntimeConfig(VolumePricingModalNotification)
